"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownOption = _styledComponents.default.div.withConfig({
  displayName: "DropdownOption",
  componentId: "smggga-0"
})(["padding:10px;background-color:", ";border:1px solid ", ";color:", ";"], function (p) {
  return p.active ? (0, _helpers.color)('primary5') : (0, _helpers.color)('white');
}, function (p) {
  return p.selected ? (0, _helpers.color)('primary100') : 'transparent';
}, function (p) {
  return p.active ? (0, _helpers.color)('primary100') : (0, _helpers.color)('black100');
});

var RenderOption = function RenderOption(option, _, __, _ref) {
  var active = _ref.active,
      selected = _ref.selected;
  return React.createElement(DropdownOption, {
    active: active,
    selected: selected
  }, option.label);
};

var _default = RenderOption;
exports.default = _default;